
import Parse from 'parse';
import React from 'react';

const ingredTypeCount = 3;

class Product extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            curProduct: null,
            ingredTypes: ["🥦 Whole Plants", "🥫 Processed", "🔬 Additives"],
            ingredFields: ["plantsData", "processedData", "additivesData"],
            ingredEmojis: ["🥦", "🥫", "🔬"],
            ingredImages: ["plants.png", "processed.png", "additives.png", "grains.png", "seeds.png", "spices.png", "products.png", "instructions.png"],
            curProductName: "Default",
            ingredArr: [],
        };

        // Creates all lines:
        for(var i=0; i < ingredTypeCount; i++) {

          // Creates an empty line
          this.state.ingredArr.push([]);
        }

        //this.state.curRecipe = this.props.recipe;
        console.log("this.props.product " + this.props.product);

        //do this to load the items
        this.selectProduct(this.props.product);
    }


    selectProduct(product) {
      //this.setState({curProduct:product});
        if (product)
          console.log('Select product ' + product.get("name"));
        else
            return;

         if (this.state.curProduct != product) 
        {
            this.state.curProduct = product;
            global.curProduct = product;

            this.state.curProductName = product.get("name");
            
            console.log("CurProduct " + JSON.stringify(product));

            //load the itemArr
            var newIngredArr = [];

            for (var i = 0; i < ingredTypeCount; i++)
            {
                var curIngredType = this.state.ingredTypes[i].toLowerCase();

                var fieldName = this.state.ingredFields[i]; ///curIngredType + "Data";
                var serData = product.get(fieldName);
                if (serData)
                {
                    console.log("Parsing serial data " + fieldName + " " + serData);
                    var serObj = JSON.parse(serData);
                    newIngredArr.push(serObj);
                }
                else
                    newIngredArr.push([]);
            }
            this.state.ingredArr = newIngredArr;

            this.forceUpdate();
        }
        //this.state.curProduct = product;
    }



    getProducts(event) {
        event.preventDefault();
        this.getProductsAux();
    }


renderIngredientType(ingredType, i) {
        let buffer = [];

        //console.log("renderIngredientType " + i + " ingredArr len " + this.state.ingredArr[i].length)
        for (var k = 0; k < this.state.ingredArr[i].length; k++)
        {
            var ingred = this.state.ingredArr[i][k];

           // console.log("ingredArr " + i + " " + ingred.name);

            /* ======================== INGREDIENT COMPONENTS =========================== */

            {
                //instructions
                var stepText = "Ingredient";

                //**/
                buffer.push( <div className="recipeIngred">
                           <span><a href="/appstore/">{this.state.ingredArr[i][k].name}</a>,</span>&nbsp;

                           <span>{this.state.ingredArr[i][k].description}</span>
                    </div>);
            }
        }
        //console.log("ingredArr length " + this.state.ingredArr[i].length);
        if ((this.state.ingredArr[i].length == 0) && (i != 3))
        {
            if (i == 0)
            {
                buffer.push( 
                                <div className="recipePostamble">No whole plants were added to this product.</div>
                            );
            }
            else if (i == 1) {
                buffer.push( 
                                <div className="recipePostamble">No processed foods were added to this product.</div>
                            );
            }
            else if (i == 2) {
                buffer.push( 
                                <div className="recipePostamble">No additives were added to this product.</div>
                            );
            }
        }
        else if (i != 3)
        {
        }

        return (
            <div>
            <b>
            {ingredType}</b><br/>
                    {buffer}
            </div>
            );
    }

    renderIngredients()
    {
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;

        let buffer = [];

        for (var i = 0; i < this.state.ingredTypes.length; i++)
        {
            var ingredType = this.state.ingredTypes[i];
            if (ingredType != undefined)
            buffer.push(<div className="recipeSectionHeader" key={69*i}>
                            {this.renderIngredientType(ingredType, i)}
                        </div>);
        }
        

        return ( <div key="11">
                {buffer}
                </div>
        );
        /*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/
    }

    renderProductV2()
    {
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;

        let buffer = [];

        var formatIngred = this.formatComment( this.state.curProduct.get("ingredients") );
        var formatWebsite = this.formatComment( this.state.curProduct.get("website") );
        var formatNotes = this.formatComment( this.state.curProduct.get("notes") );

        console.log("curProduct: "+ JSON.stringify(this.state.curProduct));

        buffer.push(<div>

                    <div className="recipeSectionHeader" key={69*1}>
                            <b>
                            Ingredients</b><br/>
                             <div className="recipeIngred">
                                 <div dangerouslySetInnerHTML={{ __html: formatIngred}} />
                            </div> 
                           
                        </div>
                    <div className="recipeSectionHeader" key={69*1}>
                            <b>
                            Notes</b><br/>
                             <div className="recipeIngred">
                                 <div dangerouslySetInnerHTML={{ __html: formatNotes}} />
                            </div> 
                           
                        </div>
                    <div className="recipeSectionHeader" key={69*1}>
                            <b>
                            Website</b><br/>
                             <div className="recipeIngred">
                                 <div dangerouslySetInnerHTML={{ __html: formatWebsite}} />
                            </div> 
                           
                        </div>

                        </div>);
        

        return ( <div key="11">
                {buffer}
                </div>
        );
        /*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/
    }

    formatComment(origComment)
    {
        if (!origComment)
          return "";

        var stringSplit = origComment.split(" ");
        var result = "";

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                result += '<a href="/appstore">' + comp + '</a>';
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
                result += '<a href="' + comp + '"">' + comp + '</a>';
            }
            else
            {
                result += comp;
            }
            result += " ";
        }

        //replace newlines with breaks
        result = result.split("\n").join("<br>");

        return result;
    }

    renderPostamble()
    {
        let buffer = [];
        var result;

        if (!this.state.curProduct)
        {
            return (<div></div>);
        }
        var formatWS = this.formatComment( this.state.curProduct.get("website") );
        var formatHash = this.formatComment( this.state.curProduct.get("hashtags") );

        result =  (
                 <div className="recipePostamble" key="-1">
                        
                        <div dangerouslySetInnerHTML={{ __html: formatWS}} />
                        <br/>
                        <div dangerouslySetInnerHTML={{ __html: formatHash}} />
                </div>
                );

        return result;
    }

    render() {
       // console.log("Rendering recipe list");
        var result = (
            <div>
            </div>

        );
        {
            var self = this;

            if (this.state.curProduct != null)
            {
                result =  (
                 <div className="recipeDiv" key="-1">
                        <span>&nbsp;{this.state.curProduct.get("name")}</span>

                        {this.renderProductV2()}


                        <br/>
                </div>
              );

            }


        }
        return result;
        /* 
                    <label className="checkbox">
                        <input type="checkbox" value="remember-me" onChange={this.handleRememberMeClick}/>
                        &nbsp; Remember me
                    </label>
                    */

    }


}

export default Product;


// WEBPACK FOOTER //
// ./src/product.jsx